module.exports = __webpack_public_path__ + "img/zuanshi.8660ac24.png";